import React, { useState, useRef, useEffect } from "react";
import { getNotes } from "../services/APIClient";
import { Container, Col, Row } from "react-bootstrap";

// Import the ShareActionCard component
import ShareActionCard from "./ShareActionCard";

import "./IndividualStudentResultsOverview.css";
import "./ClassOverview.css";

import ReturnToClassResults from "./RetrunToClassResults";
import AllResultsHistory from "./AllResultsHistory"; // Import new component
import GradeCard from "./GradeCard";
import PrintAllStudentResults from "./PrintAllStudentResults";
import RecommendationsButton from "./RecommendationsButton";
import ReturnToSencoResults from "./ReturnToSencoResults";
import Suspense from "react";
import ReportCardPrintActionCard from "./ReportCardPrintActionCard";
import PrintAllStudentResultsModal from "./PrintAllStudentResultsModal";
import SENWatchlistButton from "./SENWatchlistButton";
import useAcademicYearOptions from "../utils/useAcademicYearOptions";

function AllStudentResultsOverview(props) {
  const {
    classDetails = {}, // Provide a default empty object
    studentResults,
    rawStudentResults,
    assessmentResultsByStudent,
    schoolid,
    teacherid,
    classAssessments,
    teachers,
    assessment = {}, // Provide a default empty object
    students = [], // Provide a default empty array
    viewParent: initialViewParent,
    viewTeacher: initialViewTeacher,
    fromSencoResults,
    readingScores,
    studentResultsForHistory,
  } = props;

  console.log("AllStudentResultsOverview studentResults:", studentResults);

  // Safely access properties with optional chaining
  const gradeLevel1 = classDetails?.grade_level1;
  const gradeLevel2 = classDetails?.grade_level2;
  const trialClass = classDetails?.trial_class;

  const [toggleScoreType, setToggleScoreType] = useState("");
  const [showPrintCard, setShowPrintCard] = useState(false);
  const [printCardPosition, setPrintCardPosition] = useState({
    top: 0,
    left: 0,
  });

  // Add state for ShareActionCard
  const [showShareCard, setShowShareCard] = useState(false);
  const [shareCardPosition, setShareCardPosition] = useState({
    top: 0,
    left: 0,
  });

  // Initialize with props and create state setters
  const [viewParent, setViewParent] = useState(initialViewParent || false);
  const [viewTeacher, setViewTeacher] = useState(initialViewTeacher || false);

  const [classNotes, setClassNotes] = useState([]);

  useEffect(() => {
    if (classDetails?.id) {
      getNotes("class", classDetails.id, null)
        .then((res) => setClassNotes(res.data || []))
        .catch(() => {});
    }
  }, [classDetails?.id]);

  const detailedRef = useRef(null);
  const overviewRef = useRef(null);
  const currentViewRef = useRef(null); // New ref to track the current view

  const [currentAcademicYear] = useAcademicYearOptions({ previousYears: 0 });

  // Transform students array to match the format expected by ShareActionCard
  const formattedStudents = students.map((student) => ({
    id: student.id,
    name: student.name || student.student?.name,
  }));

  const academicYear = currentAcademicYear.display;

  return (
    <>
      <Row className="inline-block align-items-center push-down">
        <Col className="col-auto">
          <ReturnToSencoResults />
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">
            {fromSencoResults ? "SENCO Results Overview" : "Results Overview"}
          </h2>
        </Col>
        <Col className="col-auto d-flex justify-content-end">
          {fromSencoResults && (
            <SENWatchlistButton
              schoolid={schoolid}
              teachers={teachers}
              teacherid={teacherid}
              assessment={assessment}
              readingScores={readingScores}
            />
          )}
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setPrintCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              setShowPrintCard(!showPrintCard);
            }}
          >
            Print
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setShareCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              setShowShareCard(!showShareCard);
            }}
          >
            Share
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
        </Col>
        <Col className="col-auto"></Col>{" "}
        {/* Empty column to balance the layout */}
      </Row>
      <div className="class-overview-container">
        <Container className="container-shape">
          <Row className="page-description-bar">
            <Col className="col-6">
              <Row>
                <Col className="col-6">
                  <h2
                    className="page-description-header"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {assessment.name?.match(/\b(Baseline|Midpoint|End)\b/i)?.[0] ||
                      assessment.name?.split(" ")[1]} Report Cards
                  </h2>
                </Col>
              </Row>
            </Col>
            <Col className="col-4">
              <Row>
                <Col className="col-3"></Col>

                <Col className="col-1"></Col>
                <Col className="col-4">
                  {/* <RecommendationsButton onResultsPage={true} /> */}
                </Col>
              </Row>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col className="col-3">
              <PrintAllStudentResults
                studentResults={rawStudentResults || studentResults}
                toggleScoreType={toggleScoreType}
                assessmentResultsByStudent={assessmentResultsByStudent}
                isPrintOut={true}
                detailedView={true}
                teacherid={teacherid}
                schoolid={schoolid}
                teachers={teachers}
                students={students}
                buttonName={"Print Detailed"}
                classDetails={classDetails}
                overviewRef={overviewRef}
              />
            </Col>
          </Row>

          {/* Render AllResultsHistory without any conditions */}
          <div
            ref={currentViewRef}
            style={{ minHeight: "100vh", position: "relative" }}
          >
            {/* Print-only header */}
            <div className="alpaca-print-header">
              <div className="printout-logo" />
              <div className="alpaca-print-header-text">
                <span className="alpaca-print-header-year">
                  School Year:{academicYear}
                </span>
              </div>
            </div>
            <AllResultsHistory
              studentResults={studentResultsForHistory || rawStudentResults || studentResults}
              toggleScoreType={toggleScoreType}
              assessmentResultsByStudent={assessmentResultsByStudent}
              isPrintOut={false}
              detailedView={true}
              teacherid={teacherid}
              schoolid={schoolid}
              teachers={teachers}
              students={students}
              detailedRef={detailedRef}
              overviewRef={overviewRef}
              currentViewRef={currentViewRef} // Pass the new ref
              viewParent={viewParent}
              viewTeacher={viewTeacher}
              academicYear={academicYear}
            />
            {/* Print footer inside printable area */}
            {/* <div
              className="alpaca-print-footer"
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                width: "100%",
                textAlign: "center",
                fontSize: "0.9rem",
                color: "#888",
                padding: "8px 0",
                background: "white",
                zIndex: 1000,
                display: "block",
              }}
            >
              Powered by ALPACA &copy; {new Date().getFullYear()}
            </div> */}
          </div>
        </Container>
      </div>
      {showPrintCard && (
        <ReportCardPrintActionCard
          cardPosition={printCardPosition}
          handleCloseCard={() => setShowPrintCard(false)}
          overviewRef={overviewRef}
          detailedRef={detailedRef}
          currentViewRef={currentViewRef}
          studentResults={rawStudentResults || studentResults}
          toggleScoreType={toggleScoreType}
          assessmentResultsByStudent={assessmentResultsByStudent}
          teacherid={teacherid}
          schoolid={schoolid}
          students={students}
          teachers={teachers}
          detailedView={true}
          classNotes={classNotes}
          classDetails={classDetails}
        />
      )}

      {/* Add ShareActionCard */}
      {showShareCard && (
        <ShareActionCard
          cardPosition={shareCardPosition}
          handleCloseCard={() => setShowShareCard(false)}
          activeAccordionStudents={formattedStudents}
          shareResults={(zipBlob) => {
            console.log("Sharing ZIP Blob:", zipBlob);
            // Add logic to handle sharing the ZIP blob
          }}
          assessmentName={assessment?.name || "Assessment"}
          className={classDetails?.name || "Report Cards"}
          rollNumber={schoolid || "School"}
          setViewParent={setViewParent}
          setViewTeacher={setViewTeacher}
          schoolid={schoolid}
          teacherId={teacherid}
          assessmentIds={[assessment?.assessmentid || assessment?.id].filter(Boolean)}
        />
      )}
    </>
  );
}

function ClassNotesPrintSection({ classNotes, teachers, classDetails }) {
  const formatIrelandTime = (timestamp) => {
    return new Date(timestamp).toLocaleString("en-IE", {
      day: "numeric", month: "short", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Europe/Dublin",
    });
  };

  const getTeacherName = (tid) => {
    const teacher = (teachers || []).find((t) => t.id === tid);
    return teacher?.name || "Unknown";
  };

  return (
    <div style={{ marginBottom: 24, padding: "16px 0", pageBreakInside: "avoid" }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1a56db", borderBottom: "2px solid #1a56db", paddingBottom: 6, marginBottom: 4 }}>
        {classDetails?.name || "Class"} — Class Notes
      </h2>
      <p style={{ fontSize: 11, color: "#999", marginBottom: 12 }}>
        Printed: {new Date().toLocaleString("en-IE", { timeZone: "Europe/Dublin" })}
      </p>
      {classNotes.map((n) => (
        <div key={n.id} style={{ marginBottom: 10, padding: "8px 12px", borderLeft: "3px solid #1a56db", background: "#f8f9fa", borderRadius: 4 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
            {/* <span style={{ fontSize: 11, fontWeight: "bold", background: "#1a56db", color: "white", padding: "2px 8px", borderRadius: 4 }}>
              {n.note_type}
            </span> */}
            <span style={{ fontSize: 11, color: "#666" }}>
              {getTeacherName(n.teacherid)} &bull; {formatIrelandTime(n.date_created)}
            </span>
          </div>
          <div style={{ fontSize: 13, color: "#333", whiteSpace: "pre-wrap" }}>{n.note_text}</div>
        </div>
      ))}
    </div>
  );
}

export { ClassNotesPrintSection };
export default AllStudentResultsOverview;
